import React from 'react';
import { Box } from '@mui/material';
import { FileText } from 'lucide-react';
import { PARTICIPANT_PAGE_SIZE } from '../../constants';
import type { IApplicationData } from '../../interfaces';
import { ApplicationCard, CardSkeletonGrid, EmptyState, ParticipantPagination } from '../components';

export interface IApplicationsTabProps {
  applications: IApplicationData[] | null;
  totalCount: number;
  loading: boolean;
  page: number;
  onPageChange: (page: number) => void;
}

export const ApplicationsTab = ({
  applications,
  totalCount,
  loading,
  page,
  onPageChange,
}: IApplicationsTabProps) => {
  if (loading) {
    return <CardSkeletonGrid count={4} height={180} />;
  }

  if (!applications || applications.length === 0) {
    return (
      <EmptyState
        icon={FileText}
        title="No Applications Yet"
        subtitle="Jobs you apply to will be tracked here."
      />
    );
  }

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            md: 'repeat(2, 1fr)',
            lg: 'repeat(3, 1fr)',
          },
          gap: 3,
        }}
      >
        {applications.map((application) => (
          <ApplicationCard key={application.jobApplicantId} application={application} />
        ))}
      </Box>
      <ParticipantPagination
        page={page}
        totalCount={totalCount}
        pageSize={PARTICIPANT_PAGE_SIZE}
        onPageChange={onPageChange}
      />
    </>
  );
};
